import React from 'react';

const PageLoader = ({ text = 'Loading' }) => {
  return (
    <div className="page-loader">
      <div className="orbital-loader">
        <div className="orbital-ring" />
        <div className="orbital-ring" />
        <div className="orbital-ring" />
        <div className="orbital-core" />
      </div>
      <div className="loader-text">
        {text}<span className="loader-dots" />
      </div>
    </div>
  );
};

export default PageLoader;
